import React from 'react';

import styles from './EmptyState.module.css';

export default function EmptyState({
    callToActionMessage,
    pageName,
}: {
    readonly callToActionMessage: string,
    readonly pageName: string
}) {
    return (
        <div className={styles.wrapper}>
            <div
                className={styles.content}
                role="alert"
            >
                <p className={styles.mainMessage}>{`No ${pageName} yet.`}</p>
                <p>{callToActionMessage}</p>
            </div>
        </div>
    );
}
